module.exports = __webpack_public_path__ + "static/media/howto-bg-iron.9965f593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/howto-bg-iron.jpg
// module id = 576
// module chunks = 103